(function ($) {
  $(function () {

    // const defaultMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    // let activeMode = defaultMode ? 'dark' : 'light';
    // document.body.classList.add(activeMode);


    
    $('#js-heightControl').css('height', $(window).height() - $('html').height() +'px');
      

    //Change search placeholder 
    $('.search-field').attr('placeholder', 'Pretražite..');

    $('.search-submit').replaceWith('<button class="search-submit d-flex align-items-center" type="submit"><i class="icon-search mr-2"></i> <span>Pretražite</span></button>')


    var CurrentUrl = document.URL;
    var CurrentUrlEnd = CurrentUrl.split('/').filter(Boolean).pop();
    // console.log(CurrentUrlEnd);
    $(".sidebar-fixed  a").each(function () {
      var ThisUrl = $(this).attr('href');
      var ThisUrlEnd = ThisUrl.split('/').filter(Boolean).pop();

      if (ThisUrlEnd == CurrentUrlEnd) {
        $(this).closest('li').addClass('active')
      }
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('p.copy-link i').click(function () {
      var input = $(this).next();
      console.log(input);
      input.focus();
      input.select();
      document.execCommand('copy');
      $(".copied").append(`<div class="alert alert-success copied  ml-auto mr-auto" role="alert">
      <i class="icon-alert-triangle"></i> Uspešno ste kopirali link!
    </div>`).show().fadeOut(3000);
    });


    /*
     * Password protected change label
     */
    $('.password-form h4').html('Zaštićena stranica');
    $('.password-form p').html('Sadržaj je zaštićen lozinkom. Unesite lozinku kako biste otključali sadržaj.');
    $('.password-form button[type="submit"]').html('Otključaj');
    $('.password-form input[type="password"]').attr('placeholder', 'Unesite lozinku');
    $('.password-form fieldset').append('<i class="icon-eye"></i>');



    /*
     * Blocks scroll smoth
     */
    $(document).on('click', '.table-of-contents-wrapper a[href^="#"], .list-headings li a[href^="#"], .back-to-top a', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100
      }, 500);
    });


    $('.alert-danger').delay(150).fadeOut(1500);

    /*
     * Table blocks add class
     */
    // function isOnScreen(elem) {
    //   // if the element doesn't exist, abort
    //   if (elem.length == 0) {
    //     return;
    //   }
    //   var $window = jQuery(window)
    //   var viewport_top = $window.scrollTop()
    //   var viewport_height = $window.height()
    //   var viewport_bottom = viewport_top + viewport_height
    //   var $elem = jQuery(elem)
    //   var top = $elem.offset().top
    //   var height = $elem.height()
    //   var bottom = top + height

    //   return (top >= viewport_top && top < viewport_bottom) ||
    //     (bottom > viewport_top) && (top < viewport_bottom) ||
    //     (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    // }


    // window.addEventListener('scroll', function (e) {
    //   var el = $('.test');
    //   var elnew = $('.novitest');
    //   var viewport_top = $(window).scrollTop();
    //   var el_top = $('.novitest').offset().top
    //   var el_top_new = elnew.offset().top

    //   if (isOnScreen(el) || viewport_top < el_top || viewport_top < el_top_new) {
    //     el.removeClass('active');
    //   } else {
    //     $('.table-of-contents-wrapper').addClass('active');
    //     $('.table-of-contents-wrapper').removeClass('test');
    //   }



    // });

    /*
     * Navbar fixed
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top');
        $('.sidebar-fixed').addClass('active');
      } else {
        $('.site-header').removeClass('navbar-fixed-top');
        $('.sidebar-fixed').removeClass('active');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $('body').toggleClass('fixedPosition');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    $('#sidebar-fixed-btn').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $('body').toggleClass('fixedPosition');
      $(".sidebar-fixed").toggleClass('sliding-open');
    });

    /*
     * Owl carousel
     */
    $('.owl-home').owlCarousel({
      margin: 20,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: false,
      dots: false,
      animateOut: 'fadeOut',
      // navText: ["<i class='dr-arrow-left'></i>", "<i class='dr-arrow-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Open modal
     */

    $('#open-modal').on('click', function (e) {
      e.preventDefault();
      $('#modal').modal('show');
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });



    $('#play-video-btn').on('click', function () {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    })

    window.onYouTubeIframeAPIReady = function () {
      var videoModules = document.querySelectorAll('.video');
      videoModules = Array.prototype.slice.call(videoModules);
      videoModules.forEach(initializeVideoModule);
    }

    function initializeVideoModule(videoModule) {
      var player = new YT.Player(videoModule.querySelector('.video-placeholder'), {
        videoId: videoModule.dataset.videoId,
        events: {
          onStateChange: function (event) {
            var isEnded = event.data === YT.PlayerState.ENDED;
            videoModule.classList[isEnded ? 'remove' : 'add']('playing');
            if (isEnded) {
              player.destroy();
              videoModule.querySelector('.video-layer').innerHTML = (
                '<div class="video-placeholder"></div>'
              );
              initializeVideoModule(videoModule);
            }
          }
        }
      });
    }

    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });
    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });


    /*
     * Mmenu light 
     */
    var menuContainer = document.querySelector('#my-menu');
    var menu = new MmenuLight(menuContainer
      ,
      'all'
    );
    if (menuContainer) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Meni'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }


    //Dokumentacija sidebar artikle naslov/link
    $('#single-post article').children('h2').each(function (e) {
      console.log(e);
      var heading = $(this)[0].innerText;
      var headingRemove = heading.replace(/[`~!@#$%^&*()-_+{}[\]\\|,.//?;':"]/g, '');
      var headingLowerCase = headingRemove.replace(/\s+/g, '-').toLowerCase();

      $(this).attr('id', headingLowerCase); 

      if (heading) {
        $('.single-content-sidebar').show();
      }

      $('.list-headings').append(`<li><a href="#${headingLowerCase}">${heading}</a></li>`);

    });

    //Add class to table
    $('.wp-block-table table').addClass('table table-striped table-bordered table-hover');


  });
})(jQuery);